// extracted by mini-css-extract-plugin
export var table = "_x6-0";